module.exports = __webpack_public_path__ + "media/pages/assets/images/gallery/2021/january-e7b32787dbf665edf391ebbf92b1a355.png";